import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatavacina'
})
export class FormataVacinaPipe implements PipeTransform {
  transform(value: any | null): string {
    switch (value) {
      case '85':
          return "COVISHIELD - FIOCRUZ"
        break;

      case '86':
          return "CORONAVAC - BUTANTAN"
        break;

      case '87':
          return "COMIRNATY - PFIZER"
        break;

      case '88':
          return "Ad26.COV2.S - JANSSEN"
        break;

      case '89':
          return "COVID-19 RECOMBINANTE - ASTRAZENECA"
        break;
    }
  }
}

@Pipe({
  name: 'formatainstituicao'
})
export class FormataInstituicaoPipe implements PipeTransform {
  transform(value: any | null, saida: string): string {
    switch (value) {
      case '85':
          return "FIOCRUZ"
        break;

      case '86':
          return "BUTANTAN"
        break;

      case '87':
          return "PFIZER"
        break;

      case '88':
          return "JANSSEN"
        break;

      case '89':
          return "ASTRAZENECA"
        break;
    }
  }
}
